import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "../../utils/cropImage";
import "../../css/Image-cropper-modal.css";

const ImageCropper = ({
  open, 
  onClose, 
  imageSrc, 
  onCropComplete: onCropDone, 
  aspectRatio = 16 / 9,
  title = "Image Cropper",
  uploadButtonText = "UPLOAD",
  cancelButtonText = "CANCEL"
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const handleCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const handleUpload = async () => {
    try {
      if (!imageSrc || !croppedAreaPixels) {
        return;
      }
      
      const croppedImg = await getCroppedImg(imageSrc, croppedAreaPixels);
      onCropDone(croppedImg);
      onClose();
    } catch (error) {
      console.error("Crop upload failed:", error);
    }
  };

  const handleClose = () => {
    onClose();
  };

  if (!imageSrc) {
    return null;
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      BackdropProps={{
        style: { backgroundColor: "transparent" },
      }}
    >
      <div className="cropper-modal">
        <div className="cropper-header">
          <p>{title}</p>
        </div>
        <div className="cropper-preview-container">
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={aspectRatio}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={handleCropComplete}
          />
        </div>
       
        <div className="cropper-actions">
          <button onClick={handleUpload} className="upload_button">
            {uploadButtonText}
          </button>
          <button onClick={handleClose} className="cancel-button">
            {cancelButtonText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ImageCropper;